module.exports = __webpack_public_path__ + "img/11_46.983ff478.png";